import { Icon, ICONS } from 'Components/Atoms/Icon/Icon';
import NoValue from 'Components/Atoms/NoValue/NoValue';
import Tag from 'Components/Atoms/Tag/Tag';
import { useEffect, useRef, useState } from 'react';
import { useOuterClick } from 'Services/helpers';
import TagGroup from '../../TagGroup/TagGroup';
import styles from './MultiSelectField.module.sass';
import MultiSelectFieldItem from './MultiSelectFieldItem';

const MultiSelectField = ({isEdit, value: rawValue = [], onChange, fieldProperties}: any) => {
    const isEmpty = !rawValue || !Array.isArray(rawValue) || rawValue?.length == 0;
    const [data, setData] = useState<any>({
        labels: {},
        list: fieldProperties?.list || []
    });
    const [state, setState] = useState({
        isFocused: false,
        isOpen: false
    });
    const inputRef: any = useRef();
    const innerRef = useOuterClick(() => setState({
        ...state,
        isFocused: false
    }));

    useEffect(() => {
        if (!state.isFocused) return;
        inputRef?.current?.focus();
    }, [state.isFocused]);

    useEffect(() => {
        if (fieldProperties?.list) {
            const labels: any = {};
            fieldProperties?.list?.forEach((i: any) => {
                labels[i?.value] = i?.label
                
                if (i?.children) {
                    i.children.forEach((j: any) => {
                        labels[j?.value] = j?.label
                    });
                }
            });
            setData({
                ...data,
                labels
            });
        }
    }, [fieldProperties?.list, rawValue]);

    const handleClick = (value: any) => {
        if (value == null) {
            onChange([]);
            
            return;
        }

        let values: any = [...(rawValue || [])];
        for (const item of value) {
            if (values.includes(item)) {
                const index = values.indexOf(item);
                if (index > -1) {
                    values.splice(index, 1);
                }

                continue;
            }

            
            values.push(item);
        }

        onChange(values);
    }
    const handleFocusClick = () => setState({...state, isFocused: true});

    if (!isEdit) {
        if (isEmpty) {
            return <NoValue />;
        }

        return <TagGroup alignRight={!fieldProperties.alignLeft} isCollapsed={fieldProperties.isInline}>
            {
                rawValue?.map((id: any) =>
                    <Tag key={id}>
                        { data.labels?.[id] }
                    </Tag>
                )
            }
        </TagGroup>
    }

    return <div className={`
        ${styles['multiselectfield']}
        ${state.isFocused ? styles['multiselectfield--active'] : ''}
        ${fieldProperties?.isDisabled ? styles['multiselectfield--disabled'] : ''}
    `}
        onClick={handleFocusClick}
        ref={innerRef}
    >
        {
            isEmpty &&
            <div className={`${styles['multiselectfield__content']}`}>
                <input placeholder={'Selecteer een waarde...'} style={{pointerEvents: 'none'}}/>
            </div>
        }
        {
            !isEmpty && <>
                <TagGroup
                    disableAlphabeticOrder={!!fieldProperties?.disableAlphabeticOrder}
                    style={{ flexGrow: 1 }}
                >
                    {
                        rawValue?.map((id: any) =>
                            <Tag
                                key={id}
                                onDelete={() => handleClick([id])}
                            >
                                { data.labels?.[id] }
                            </Tag>
                        )
                    }
                </TagGroup>

                <div className={styles['multiselectfield__icon']} onClick={() => handleClick(null)}>
                    <Icon type={ICONS.CLOSE} size={'xsmall'} isCircled />
                </div>
            </>
        }
        <div className={styles['multiselectfield__icon']}>
            <Icon type={ICONS.CHEVRON_DOWN} size={'small'}/>
        </div>
        {
            state.isFocused &&
            <div className={styles['multiselectfield__dropdown']}>
                {
                    data.list.map((item: any) =>
                        <MultiSelectFieldItem
                            key={item?.value}
                            item={item}
                            labels={data?.labels}
                            activeValues={rawValue}
                            searchQuery={''}
                            onClick={(v) => handleClick(v)}
                        />
                    )
                }
                { data.list.length == 0 && <div className={`${styles['multiselectfield__dropdown__item']}`} style={{fontStyle: 'italic'}}>Geen resultaten gevonden...</div>}
            </div>
        }
    </div>;
}

export default MultiSelectField;